import makeStyles from "@material-ui/core/styles/makeStyles";
import PropTypes from "prop-types";
import TreeItem from "@material-ui/lab/TreeItem";
import clsx from "clsx";
import Typography from "@material-ui/core/Typography";
import {multiLanguageValue} from "../../../../../../../JsonScreen/Utils/lib";
import {useSelector} from "react-redux";

const useTreeItemStyles = makeStyles((theme) => ({
    disabledItem: {
        opacity: 0.5
    },
    "@global": {
        ".MuiTreeItem-root.Mui-selected > .MuiTreeItem-content .MuiTreeItem-label:hover, .MuiTreeItem-root.Mui-selected:focus > .MuiTreeItem-content .MuiTreeItem-label": {
            backgroundColor: "transparent"
        }
    },
    root: {
        color: theme.palette.text.secondary,
        borderRadius: 0,
        '&:hover > $content': {
            backgroundColor: theme.palette.action.hover,
            borderRadius: 0,
        },
        '&:focus > $content, &$selected > $content': {
            backgroundColor: `var(--tree-view-bg-color, ${theme.palette.grey[400]})`,
            borderRadius: 0,
            color: 'var(--tree-view-color)',
        },
        '&:focus > $content $label, &:hover > $content $label, &$selected > $content $label': {
            backgroundColor: 'transparent',
            borderRadius: 0,
        },
        padding: '4px 0'
    },
    rootDisabled: {
        color: theme.palette.text.secondary,
        '&:hover > $content': {
            backgroundColor: 'transparent',
        },
        '&:focus > $content, &$selected > $content': {
            backgroundColor: `transparent`,
            color: 'var(--tree-view-color)',
        },
        '&:focus > $content $label, &:hover > $content $label, &$selected > $content $label': {
            backgroundColor: 'transparent',
        },
    },
    content: {
        color: theme.palette.text.secondary,
        borderTopRightRadius: theme.spacing(2),
        borderBottomRightRadius: theme.spacing(2),
        paddingTop: 2,
        paddingBottom: 2,
        paddingRight: 15,
        fontWeight: theme.typography.fontWeightMedium,
        '$expanded > &': {
            fontWeight: theme.typography.fontWeightRegular,
        },
        paddingLeft: props => props.level * 7
    },
    group: {
        marginLeft: 0,
        //paddingLeft: 10,
        '& $content': {
            //paddingLeft: props => props.level * 20,
        },
    },
    expanded: {},
    selected: {},
    label: {
        fontWeight: 'inherit',
        color: 'inherit',
    },
    labelRoot: {
        display: 'flex',
        alignItems: 'center',
        padding: 0,
    },
    labelIcon: {
        marginRight: theme.spacing(1),
    },
    labelText: {
        fontWeight: 'normal',
        flexGrow: 1,
    },
}));
const ComponentItem = (props) => {
    const userLanguage = useSelector(state => state.app.userLanguage);
    const {level, component, setPanelType, ...other} = props;
    const classes = useTreeItemStyles({level});
    return (
        <TreeItem
            label={
                <>
                    <Typography>
                        {component.id?.charAt(0).toUpperCase() + component.id?.slice(1) || "Container"}
                        {component.properties?.label && (
                            <>
                                &nbsp;|&nbsp;<i style={{

                            }}>{multiLanguageValue(component.properties.label, userLanguage)}</i>
                            </>
                        )}
                    </Typography>
                </>
            }
            className={clsx(classes.className)}
            style={{
                '--tree-view-color': '#5d5d5d',
                '--tree-view-bg-color': '#bdbdbd',
            }}
            classes={{
                root: clsx(classes.root),
                content: classes.content,
                expanded: classes.expanded,
                selected: classes.selected,
                group: classes.group,
                label: classes.label,
            }}
            {...other}
        />
    )
}
export default ComponentItem;

ComponentItem.propTypes = {
    level: PropTypes.number,
    component: PropTypes.any
}